import React, { Component } from "react";

class DecklistFooter extends Component {
  render() {
    return (
      <tr>
        <td colSpan='4'>{"Total: " + this.props.deckcount}</td>
        <td colSpan='4'>{"Nanobots: " + this.props.nanoCost}</td>
      </tr>
    );
  }
}

export default DecklistFooter;



// WEBPACK FOOTER //
// ./src/DeckBuilderComponents/DecklistFooter.js